import { useCallback, useEffect, useState } from 'react';
import {
  BidderFileResponse,
  BidderFileStatus,
  listBidderFiles,
} from 'services/actions/ai_management_files';

export interface BidderFile {
  key: string;
  name: string;
  source: string;
  sourceLabel: string;
  status: BidderFileStatus;
  generatedAt: string | null;
  generation: 'latest' | 'previous' | null;
  requirementTitle: string | null;
  downloadUrl: string;
}

interface State {
  id: number | null;
  files: BidderFile[];
  error: boolean;
}

const toBidderFile = (file: BidderFileResponse): BidderFile => ({
  key: file.id,
  name: file.filename,
  source: file.source,
  sourceLabel: file.source_label,
  status: file.status,
  generatedAt: file.generated_at ?? null,
  generation: file.generation ?? null,
  requirementTitle: file.requirement_title ?? null,
  downloadUrl: file.download_url,
});

export function useBidderFiles(biddingId: number | null) {
  const [state, setState] = useState<State>({ id: null, files: [], error: false });
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!biddingId) {
      setState({ id: null, files: [], error: false });
      return undefined;
    }

    let active = true;

    listBidderFiles(biddingId)
      .then((response) => {
        if (!active) return;
        const list = response?.data?.files;
        if (!Array.isArray(list)) {
          setState({ id: biddingId, files: [], error: true });
          return;
        }
        setState({ id: biddingId, files: list.map(toBidderFile), error: false });
      })
      .catch((err) => {
        console.error(`Erro ao listar os arquivos do licitante da licitacao ${biddingId}:`, err);
        if (active) setState({ id: biddingId, files: [], error: true });
      });

    return () => {
      active = false;
    };
  }, [biddingId, version]);

  const reload = useCallback(() => setVersion((current) => current + 1), []);

  const settled = state.id === biddingId;

  return {
    files: settled ? state.files : [],
    loading: !!biddingId && !settled,
    error: settled && state.error,
    reload,
  };
}
